export const apiUrl = process.env.NODE_ENV !== 'production' ? 'http://localhost:8000' : 'https://ted-task-manager.herokuapp.com';

export const LOCAL_STORAGE_TOKEN_NAME = 'todo-mern';
